// @owners { team: patients }
import { useEffect } from 'react';
import { clearRegistrationNotifications } from '~shared/actions/auth';
import { clearDeliveryNotifications } from '~shared/actions/deliveries';
import { useDispatchShared } from '~shared/store';

/**
 * When a component unmounts, clear delivery and registration notifications
 */
export const useRemoveNotifications = () => {
  const dispatch = useDispatchShared();

  useEffect(() => {
    return () => {
      dispatch(clearDeliveryNotifications());
      dispatch(clearRegistrationNotifications());
    };
  }, [dispatch]);
};
